import { useSelector } from 'react-redux';
import { RootState } from '../state/store';

export const useCompany = () => {
  const selectedCompany = useSelector(
    (state: RootState) => state.companies.selectedCompany
  );

  if (!selectedCompany) {
    return {
      companyId: 0,
      companyName: 'na',
    };
  }

  return {
    companyId: selectedCompany.id,
    companyName: selectedCompany.companyName,
  };
};
